"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();
import type { StaticImageData } from "next/image";
import { useLocale, useTranslations } from "next-intl";
import type React from "react";
import type { Job, Media as MediaType } from "@/payload-types";
import "./index.scss";
import Container from "@/components/Container";
import { CMSLink } from "@/components/Link";
import { Media } from "@/components/Media";
import RichText from "@/components/RichText";
import { Link } from "@/i18n/routing";

export type categoryImageType =
	| {
			image?: string | MediaType | null | undefined;
			category?: string | null | undefined;
			id?: string | null | undefined;
	  }[]
	| undefined;

const PageClient: React.FC<{
	job: Job;
	categoryImage: categoryImageType;
	staticImage?: StaticImageData;
}> = ({ job, staticImage, categoryImage }) => {
	const {
		title,
		publishedAt,
		stateName,
		locationsQuestion,
		layout,
		locationQuestionVisible,
		locationQuestionType,
		hybrid,
		experienceCode,
		employmentTypeCode,
		educationCode,
		description,
		careersApplyUrl,
		careersUrl,
		categoryCode,
		locations,
		countryCode,
		country,
		meta,
		city,
		companyName,
		postalCode,
		stateCode,
		status,
		sharingDescription,
		maxHoursPerWeek,
		minHoursPerWeek,
		onSite,
		optionsCoverLetter,
		optionsCv,
		optionsPhone,
		optionsPhoto,
		sharingTitle,
		remote,
		tags,
		department,
		street,
		updatedAt,
		requirements,
		mailboxEmail,
	} = job;

	const t = useTranslations("Jobs");
	const locale: "en" | "nl" | "fr" = useLocale() as "en" | "nl" | "fr";
	const url = `/jobs/${job.slug}/apply`;
	const banner =
		meta?.image ?? (categoryImage ? categoryImage[0]?.image : null);
	return (
		<div className="job_item">
			{banner && (
				<div className="banner_block">
					<div className="banner_block-wrapper">
						<Media
							className="banner_block-image"
							src={staticImage}
							resource={banner}
							fill
						/>
						<Container>
							<div className="split-link">
								<div className="back-to-link">
									<span>{"<"}</span>
									<Link
										href={
											locale === "en"
												? "/come-work-at-encon"
												: "/werken-bij-encon"
										}
									>
										{t("backToJobs")}
									</Link>
								</div>
								<div className="title">
									<h1>{title}</h1>
									<CMSLink
										url={url}
										label={t("apply")}
										appearance="secondary"
									/>
								</div>
							</div>
						</Container>
					</div>
				</div>
			)}
			<Container>
				<div className="two_column_block first">
					<div className="two_column image left">
						<div className="rich_text">
							{description &&
								(typeof description === "string" ? (
									<div
										className="rich_text"
										// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
										dangerouslySetInnerHTML={{ __html: description }}
									/>
								) : (
									<RichText enableGutter={false} data={description} />
								))}
							<CMSLink url={url} label={t("apply")} appearance="primary" />
						</div>
					</div>
				</div>
				<div className="two_column_block">
					<div className="two_column image right">
						<div className="rich_text">
							<h2>Requirements/Profile</h2>
							{requirements &&
								(typeof requirements === "string" ? (
									<div
										className="rich_text"
										// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
										dangerouslySetInnerHTML={{ __html: requirements }}
									/>
								) : (
									<RichText enableGutter={false} data={requirements} />
								))}
							<CMSLink url={url} label={t("apply")} appearance="primary" />
						</div>
					</div>
				</div>
			</Container>
		</div>
	);
};

export default PageClient;
